import React from "react";
import PropTypes from "prop-types";
import { Box, Dropdown, Text } from "samba-ui";

const SetFilters = ({ filters, selectedFilters, setSelectedFilters }) => {
  const defaultFilters = filters
    .filter(f => f.isDefault)
    .map(f => ({ label: f.name, value: f.id, removeIcon: f.isDefault }));
  filters = filters.map(filter => {
    return {
      label: filter.name,
      value: filter.id,
      removeIcon: filter.isDefault
    };
  });
  return (
    <Box>
      <Text fontSize={1} fontWeight={500}>
        Set Permission
      </Text>
      <Dropdown
        isMulti
        isClearable={false}
        placeholder="Set Permissions"
        options={filters}
        selected={selectedFilters}
        onSelect={selected => {
          // if selected doesnt include defaultFilter add them here.
          defaultFilters.forEach(f => {
            const exists = selected.find(s => s.label === f.label);
            if (!exists) {
              selected.push(f);
            }
          });
          setSelectedFilters(selected);
        }}
      />
    </Box>
  );
};

SetFilters.propTypes = {
  filters: PropTypes.array,
  selectedFilters: PropTypes.array,
  setSelectedFilters: PropTypes.func
};

export default SetFilters;
